import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { PACK_HASH } from '@app-types/home-pack';

import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY, TECHNOLOGY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class TabletJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.TABLET;
    protected readonly showComparatorSelection = false;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_TABLET;
    protected readonly wordings = {
        mainTitle: 'Série Spéciale Bbox Tablette',
        noFiber: "En attendant l'arrivée de la fibre...",
    };
    protected readonly tracking = {
        page: 'Eligibilite_test_tablet',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_tablette',
        },
    };
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        alertTitle: 'La fibre est nécessaire pour profiter de la série spéciale Bbox Tablette',
        alertDescription: "En attendant d'être éligible, vous pouvez voir les offres disponibles chez vous.",
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Popin_adresse_non_eligible_tablet',
            nomClic: 'Ok',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_tablet',
            nomClic: 'Eligibilite_ko_tablet',
        },
        buttonLabel: 'Voir les offres disponibles',
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: paths.eligibilityTest(),
    };
    protected readonly technologies = [TECHNOLOGY.FTTH];
    protected readonly showComboProductSlug = [PACK_HASH.TABLET, PACK_HASH.IPAD];
    protected readonly extraCmsBlockByTab = {};
}
